import ManageCurrentAcc from "../pages/customer/accounts/current/ManageCurrentAcc";
import ManageSavingsAcc from "../pages/customer/accounts/savings/ManageSavingsAcc";
import ManageLoansAcc from "../pages/customer/accounts/loans/ManageLoansAcc";
import ManageMoneyMarketAcc from "../pages/customer/accounts/moneyMarket/ManageMoneyMarketAcc";
import NewLoanAccount from "../pages/customer/accounts/loans/NewLoanAccount";
import DetailSavingsAccount from "../pages/customer/accounts/savings/DetailSavingsAccount";
import NewSavingsAccount from "../pages/customer/accounts/savings/NewSavingsAccount";
import ManageFixedDepositAccount from "../pages/customer/accounts/fixedDeposit/ManageFixedDepositAccount";
import NewFixedDepositAccount from "../pages/customer/accounts/fixedDeposit/NewFixedDepositAccount";
import EditFixedDepositAccount from "../pages/customer/accounts/fixedDeposit/EditFixedDepositAccount";
import NewCurrentAccount from "../pages/customer/accounts/current/NewCurrentAcc";
import DetailCurrentAccount from "../pages/customer/accounts/current/DetailCurrentAcc";
import EditCurrentAcc from "../pages/customer/accounts/current/EditCurrentAcc";
import DetailLoanAccount from "../pages/customer/accounts/loans/DetailLoanAccount";
import AddLoanCharge from "../pages/customer/accounts/loans/actions/AddLoanCharge";
import LoanPrepayment from "../pages/customer/accounts/loans/actions/LoanPrepayment";
import AssignLoanOfficer from "../pages/customer/accounts/loans/actions/AssignLoanOfficer";
import Foreclosure from "../pages/customer/accounts/loans/actions/Foreclosure";
import MakeRepayment from "../pages/customer/accounts/loans/actions/LoanRepayment";
import UndoDisbursal from "../pages/customer/accounts/loans/actions/UndoDisbursal";
import WaiveInterest from "../pages/customer/accounts/loans/actions/WaiveInterest";
import Reschedule from "../pages/customer/accounts/loans/actions/Reschedule";
import WriteOff from "../pages/customer/accounts/loans/actions/WriteOff";
import Close from "../pages/customer/accounts/loans/actions/Close";
import CloseAsRescheduled from "../pages/customer/accounts/loans/actions/CloseAsRescheduled";
import ViewGuarantors from "../pages/customer/accounts/loans/actions/ViewGuarantors";
import CreateGuarantor from "../pages/customer/accounts/loans/actions/CreateGuarantor";
import RecoverFromGuarantor from "../pages/customer/accounts/loans/actions/RecoverFromGuarantor";
import PostInterestAsOn from "../pages/customer/accounts/savings/actions/PostInterestAsOn";
import Deposit from "../pages/customer/accounts/savings/actions/Deposit";
import Withdraw from "../pages/customer/accounts/savings/actions/Withdraw";
import Hold from "../pages/customer/accounts/savings/actions/HoldSavingsAcc";
import AssignStaff from "../pages/customer/accounts/savings/actions/AssignStaff";
import AddCharge from "../pages/customer/accounts/savings/actions/AddSavingsAccCharge";
import CloseSavings from "../pages/customer/accounts/savings/actions/CloseSavingsAcc";
import ManageAccount from "../pages/customer/accounts/savings/actions/ManageAccount";
import Passfort from "../pages/customer/accounts/savings/actions/Passfort";
import TransferFunds from "../pages/customer/accounts/savings/actions/TransferFunds";
// import SearchSavingsJournalEntries from "../pages/customer/accounts/savings/actions/SavingsJournalEntries";
// import ViewSavingsJournalEntries from "../pages/customer/accounts/savings/actions/ViewJournalEntries";
import CurrentJournalEntries from "../pages/customer/accounts/current/CurrentJournalEntries";
import SearchCurrentAccJournalEntry from "../pages/customer/accounts/current/SearchCurrentAccJournalEntry";
import DetailCurrentAccJournalEntry from "../pages/customer/accounts/current/DetailCurrentAccJournalEntry";
import SavingsAccManageJournalEntries from "../pages/customer/accounts/savings/tabs/transactions/SavingsAccManageJournalEntries";
import SavingsAccDetailJournalEntries from "../pages/customer/accounts/savings/tabs/transactions/SavingsAccDetailJournalEntries";
import SearchJournalEntries from "../pages/customer/accounts/loans/tabs/transactions/SearchJournalEntries";
import DetailJournalEntry from "../pages/customer/accounts/loans/tabs/transactions/DetailJournalEntry";
import ViewJournalEntries from "../pages/customer/accounts/loans/tabs/transactions/ViewJournalEntries";

// SAVINGS ACCOUNT
import SavingsMainActionPage from "../pages/customer/accounts/savings/actions/SavingsMainActionPage";

// CURRENT ACCOUNT
import CurrentMainActionPage from "../pages/customer/accounts/current/actions/CurrentMainActionPage";
import EditManageCurrentAcc from "../pages/customer/accounts/current/actions/editCurrentAcc/EditManageCurrentAcc";
import LoanMainActionPage from "../pages/customer/accounts/loans/actions/LoanMainActionPage";
import EditKycCurrentAcc from "../pages/customer/accounts/current/actions/editCurrentAcc/EditKycCurrentAcc";

//FIX/TERM DEPOSIT
import NewTermDepositAcc from "../pages/customer/accounts/TermDeposit/NewTermDepositAcc";
import ManageTermDepositAcc from "../pages/customer/accounts/TermDeposit/ManageTermDepositAcc";
// import EditKycCurrentAcc from "../pages/customer/accounts/current/actions/editCurrentAcc/EditKycCurrentAcc";
import RescheduleRequest from "../pages/customer/accounts/loans/actions/RescheduleRequest";
import FixedDepositsMainActionPage from "../pages/customer/accounts/fixedDeposit/actions/FixedDepositsMainActionPage";
import DetailFixedDepositAccount from "../pages/customer/accounts/fixedDeposit/DetailFixedDepositAccount";

// RECURRING DEPOSIT
import ManageRecurringDepositAcc from "../pages/customer/accounts/recurringDeposit/ManageRecurringDepositAcc";
import DetailRecurringDepositAccount from "../pages/customer/accounts/recurringDeposit/DetailRecurringDepositAccount";
import RecurringDepositsMainActionPage from "../pages/customer/accounts/recurringDeposit/actions/RecurringDepositsMainActionPage";
import NewRecurringDepositAcc from "../pages/customer/accounts/recurringDeposit/NewRecurringDepositAcc";
import NewMoneyMarketAccount from "../pages/customer/accounts/moneyMarket/NewMoneyMarketAccount";
import UnApprovedLoans from "../pages/customer/accounts/loans/view/UnApprovedLoans";
import RecurringAccManageJournalEntries from "../pages/customer/accounts/recurringDeposit/tabs/transactions/RecurringAccManageJournalEntries";
import RecurringAccDetailJournalEntries from "../pages/customer/accounts/recurringDeposit/tabs/transactions/RecurringAccDetailJournalEntries";
import FixedAccDetailJournalEntries from "../pages/customer/accounts/fixedDeposit/tabs/transactions/FixedAccDetailJournalEntries";
import FixedAccManageJournalEntries from "../pages/customer/accounts/fixedDeposit/tabs/transactions/FixedAccManageJournalEntries";
// MONEY MARKET

export default [
  {
    path: "/acc0101",
    component: ManageCurrentAcc,
    isProtected: true,
  },
  {
    path: "/acc0102",
    component: ManageSavingsAcc,
    isProtected: true,
  },
  {
    path: "/edit-savings-account",
    // component: EditSavingsAcc,
    isProtected: true,
  },
  {
    path: "/edit-current-account",
    component: EditCurrentAcc,
    isProtected: true,
  },
  {
    path: "/detail-savings-account",
    component: DetailSavingsAccount,
    isProtected: true,
  },
  {
    path: "/detail-current-account",
    component: DetailCurrentAccount,
    isProtected: true,
  },
  {
    path: "/new-savings-account",
    component: NewSavingsAccount,
    isProtected: true,
  },
  {
    path: "/new-Current-account",
    component: NewCurrentAccount,
    isProtected: true,
  },
  {
    path: "/acc0103",
    component: ManageLoansAcc,
    isProtected: true,
  },
  // {
  //   path: "/acc0104",
  //   component: ManageMoneyMarketAcc,
  //   isProtected: true,
  // },
  {
    path: "/new-acc0103",
    component: NewLoanAccount,
    isProtected: true,
  },
  {
    path: "/acc0106",
    component: ManageFixedDepositAccount,
    isProtected: true,
  },
  {
    path: "/new-fixed-deposit-account",
    component: NewFixedDepositAccount,
    isProtected: true,
  },
  {
    path: "/edit-fixed-deposit-account",
    component: EditFixedDepositAccount,
    isProtected: true,
  },
  {
    path: "/detail-acc0103",
    path: "/detail-loan-account",
    component: DetailLoanAccount,
    isProtected: true,
  },
  {
    path: "/add-loan-charge",
    component: AddLoanCharge,
    isProtected: true,
  },
  {
    path: "/loan-prepayment",
    component: LoanPrepayment,
    isProtected: true,
  },
  {
    path: "/assign-loan-officer",
    component: AssignLoanOfficer,
    isProtected: true,
  },
  {
    path: "/foreclosure",
    component: Foreclosure,
    isProtected: true,
  },
  {
    path: "/make-repayment",
    component: MakeRepayment,
    isProtected: true,
  },
  {
    path: "/undo-disbursal",
    component: UndoDisbursal,
    isProtected: true,
  },
  {
    path: "/waive-interest",
    component: WaiveInterest,
    isProtected: true,
  },
  {
    path: "/reschedule",
    component: Reschedule,
    isProtected: true,
  },
  {
    path: "/write-off",
    component: WriteOff,
    isProtected: true,
  },
  {
    path: "/close",
    component: Close,
    isProtected: true,
  },
  {
    path: "/close-as-rescheduled",
    component: CloseAsRescheduled,
    isProtected: true,
  },

  {
    path: "/view-guarantors",
    component: ViewGuarantors,
    isProtected: true,
  },
  {
    path: "/create-guarantor",
    component: CreateGuarantor,
    isProtected: true,
  },
  {
    path: "/recover-from-guarantor",
    component: RecoverFromGuarantor,
    isProtected: true,
  },
  {
    path: "/post-interest",
    component: PostInterestAsOn,
    isProtected: true,
  },
  {
    path: "/deposit",
    component: Deposit,
    isProtected: true,
  },
  {
    path: "/withdraw",
    component: Withdraw,
    isProtected: true,
  },

  {
    path: "/hold",
    component: Hold,
    isProtected: true,
  },
  {
    path: "/assign-staff",
    component: AssignStaff,
    isProtected: true,
  },

  {
    path: "/add-charge",
    component: AddCharge,
    isProtected: true,
  },
  {
    path: "/close-savings",
    component: CloseSavings,
    isProtected: true,
  },
  {
    path: "/manage-account",
    component: ManageAccount,
    isProtected: true,
  },
  {
    path: "/passfort",
    component: Passfort,
    isProtected: true,
  },
  {
    path: "/transfer-funds",
    component: TransferFunds,
    isProtected: true,
  },
  {
    path: "/search-journal-entries",
    component: SearchJournalEntries,
    isProtected: true,
  },

  {
    path: "/detail-journal-entry",
    component: DetailJournalEntry,
    isProtected: true,
  },
  {
    path: "/current-journal-entries",
    component: CurrentJournalEntries,
    isProtected: true,
  },
  {
    path: "/search-CurrentAccJournalEntry",
    component: SearchCurrentAccJournalEntry,
    isProtected: true,
  },
  {
    path: "/detail-current-account-journal-entry",
    component: DetailCurrentAccJournalEntry,
    isProtected: true,
  },
  {
    path: "/savings-journal-entries",
    component: SavingsAccManageJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-savings-journal-entries",
    component: SavingsAccDetailJournalEntries,
    isProtected: true,
  },

  // SAVING ACCOUNT
  {
    path: "/savings-account-action",
    component: SavingsMainActionPage,
    isProtected: true,
  },
  // CURRENT ACCOUNT
  {
    path: "/current-account-action",
    component: CurrentMainActionPage,
    isProtected: true,
  },
  {
    path: "/edit-kyc-fields",
    component: EditKycCurrentAcc,
    isProtected: true,
  },
  {
    path: "/edit-manage-current-account",
    component: EditManageCurrentAcc,
    isProtected: true,
  },
  //END OF CURRENT ACCOUNT

  //FIX/TERM DEPOSIT
  {
    path: "/acc0105",
    component: ManageTermDepositAcc,
    isProtected: true,
  },
  {
    path: "/new-term-deposit-account",
    component: NewTermDepositAcc,
    isProtected: true,
  },

  // LOAN ACCOUNT
  {
    path: "/view-reschedule-request",
    component: RescheduleRequest,
    isProtected: true,
  },
  {
    path: "/loan-account-action",
    component: LoanMainActionPage,
    isProtected: true,
  },
  {
    path: "/view-journal-entries",
    component: ViewJournalEntries,
    isProtected: true,
  },

  //END OF LOAN ACCOUNT

  // FIXED DEPOSIT ACCOUNT
  {
    path: "/fixed-deposit-account-action",
    component: FixedDepositsMainActionPage,
    isProtected: true,
  },
  {
    path: "/detail-fixed-deposit-account",
    component: DetailFixedDepositAccount,
    isProtected: true,
  },
  {
    path: "/fixed-journal-entries",
    component: FixedAccManageJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-fixed-journal-entries",
    component: FixedAccDetailJournalEntries,
    isProtected: true,
  },
  //END OF FIXED DEPOSIT ACCOUNT

  // RECURRING DEPOSIT ACCOUNT
  {
    path: "/acc0107",
    component: ManageRecurringDepositAcc,
    isProtected: true,
  },
  {
    path: "/detail-recurring-deposit-account",
    component: DetailRecurringDepositAccount,
    isProtected: true,
  },
  {
    path: "/recurring-deposit-account-action",
    component: RecurringDepositsMainActionPage,
    isProtected: true,
  },
  {
    path: "/new-recurring-deposit-account",
    component: NewRecurringDepositAcc,
    isProtected: true,
  },
  {
    path: "/recurring-journal-entries",
    component: RecurringAccManageJournalEntries,
    isProtected: true,
  },
  {
    path: "/detail-recurring-journal-entries",
    component: RecurringAccDetailJournalEntries,
    isProtected: true,
  },

  // MONEY MARKET

  {
    path: "/acc0108",
    component: ManageMoneyMarketAcc,
    isProtected: true,
  },

  {
    path: "/new-acc0108",
    component: NewMoneyMarketAccount,
    isProtected: true,
  },
  {
    path: "/loan-approval",
    component: UnApprovedLoans,
    isProtected: true,
  },
];
